<template>
  <div class="myhome-page">
    <div class="myhome-info">
      <div class="b-home-page">
        <div class="home-page-top">
          <div class="top-img">
            <img :src='info.avatarName' alt />
          </div>
          <div class="top-p">
            <p>{{info.realName ? info.realName : info.nickName}}</p>
            <p>{{info.phone}}</p>
          </div>
        </div>
        <div class="home-page-icon">
          <div @click="checkIcon(item)" class="page-icon-size" v-for="(item,index) in iconlist" :key="index">
            <img class="icon-size" :src="item.icon" alt />
            <p>{{item.value}}</p>
          </div>
        </div>
      </div>
      <div class="myhome-info-bottom">
        <ul class="info-list-top">
          <li
            :class="isLinkTop==item.type?'list-style list-check-style':'list-style'"
            v-for="(item,index) in liListTop"
            :key="index"
            @click="checkTopLi(item)"
          >{{item.name}}</li>
        </ul>
        <div class="info-list-bottom" v-if="isLinkTop=='product'">
          <div>
            <ul class="info-dataList">
              <li
                v-for="(item,index) in productList"
                :key="index"
                class="li-style2"
                @click="chooseLi2(item,index)"
              >
                {{item.name}}
                <span
                  :class="isLinkBot==index ? 'li-style2 li-check-style2' : 'li-style2'"
                >{{item.value.length}}</span>
                <svg-icon v-if="isLinkBot==index" icon-class="home_line2"></svg-icon>
              </li>
            </ul>
            <div class="info-list-list" v-for="(item,index) in productList" :key="index">
              <div v-if="item.name=='保险' && leave==item.name">
                <div
                  class="bank-list"
                  v-for="(ctem, index) in item.value"
                  :key="index"
                >
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-left-img">
                        <img :src="ctem.thumbnail" alt />
                      </div>
                      <div>
                        <p class="product-list-title">{{ctem.name}}</p>
                        <p class="product-list-summary">手续简单抵押率高</p>
                      </div>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="ctem.digest"></p>
                  </div>
                </div>
              </div>
              <div v-if="item.name!='保险' && leave==item.name">
                <div
                  class="bank-list product-safe"
                  v-for="(ctem, index) in item.value"
                  :key="index"
                >
                  <div class="product-safe-left">
                    <img :src="ctem.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{ctem.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="ctem.digest" class="product-list-summary"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isLinkTop=='article'">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :offset=1 :finished="finished" finished-text="没有更多了" @load="onLoad">
              <div class="home-data-list" v-for="(item,index) in dataList1 " :key="'home1'+index">
                <div
                  class="home-list-sty"
                  @click.prevent="goToDetails(item.artcId,item.coverLink)"
                >
                  <div class="list-left">
                    <img :src="item.coverLink" alt />
                  </div>
                  <div class="list-right">
                    <div class="list-r-tit">
                      <!-- <img src="./img/home_name0.png" alt /> -->
                      <svg-icon icon-class="home_name2"></svg-icon>
                      <span>{{item.title}}</span>
                    </div>
                    <div class="list-r-foot">
                      <span>阅读{{ item.viewCount }}次</span>
                      <span>转发{{ item.fwdCount }}次</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      info:{},
      iconlist: [
        {
          icon: require('./img/Bicon1.png'),
          value: '我的积分',
          url:'/tentative/details'
        },
        {
          icon: require('./img/Bline.png'),
          value: ''
        },
        {
          icon: require('./img/Bicon2.png'),
          value: '提现',
          url:'/myFunds/details'
        },
        {
          icon: require('./img/Bline.png'),
          value: ''
        },
        {
          icon: require('./img/Bicon3.png'),
          value: '访问足迹',
          url:'/visitFootprint'
        },
      ],
      isLinkTop: 'product',
      isLinkBot: '0',
      liListTop: [
        {
          name: '我推荐的产品',
          type: 'product'
        },
        {
          name: '编辑推荐产品',
          type: 'edit'
        },
        {
          name: '我分享的文章',
          type: 'article'
        },
      ],
      liListBottom: [
        {
          name: '银行',
          type: '1'
        },
        {
          name: '保险',
          type: '2'
        },
        {
          name: '教育',
          type: '3'
        },
      ],
      leave: '',
      dataList1: [],
      productList: [],
      loading: false,
      finished: false,
      refreshing: false,
      rowNum: 5,
      nowPage: 0
    }
  },
  mounted() {
    this.fatchdata()
    this.getUser()
  },
  methods: {
    getUser() {//获取用户信息
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
        this.info = res.data.data
      })
    },
    checkIcon(item){//icon
      this.$router.push(item.url)
    },
    goToDetails(id){ //文章详情
      this.$router.push({
        name: "articleDetails",
        query: {
          articleId: id,
          showLongBtn: "n"
        }
      });
    },
    onLoad() {
      this.nowPage++
      this.loading = true
      this.finished = false
      this.refreshing = false
      this.getArticles()
    },
    onRefresh() {
      this.nowPage=0
      this.dataList1=[]
      this.onLoad()
    },
    getProductType() {//产品导航列表
      this.$fetchGet(URL.ProductType.url).then(res => {
        // this.liList=res.data.data
        let list = res.data.data
        list.unshift({ id: '', name: '全部' })
        this.liList = list
      })
    },
    businessCard() {
      this.$router.push('/businessCard')
    },
    checkTopLi(value) {
      this.isLinkTop = value.type
      this.dataList1=[]
      this.nowPage=0
      if (this.isLinkTop == 'edit') {
        this.$router.push({ path: '/productListEdit'})
      }
    },
    getArticles() {
      let unionid = localStorage.getItem('unionid')
      let data = {
        unionid: unionid,
        row_num: this.rowNum,
        now_page: this.nowPage,
        artcType: 'ARTUPLD'
      }
      this.$fetchPost(URL.articlesShared.url, data).then(res => {
        this.dataList1=this.dataList1.concat(res.data.data.list)
        this.loading = false
        if (res.data.data.total <= this.dataList1.length) {
          this.finished = true
          this.refreshing = false
        }
      })
    },
    chooseLi2(item, i) {
      this.isLinkBot = i
      this.leave = item.name
    },
    fatchdata() {
      this.$fetchPost(URL.recommendProduct.url, { phoneNo: localStorage.getItem('phone') }).then(res => { 
        this.productList = res.data.data;
        this.leave=res.data.data[0].name
      })
    },
  }
}
</script>

<style lang="less" scoped>
.b-home-page {
  font-family: PingFang SC;
  font-weight: Medium;
  img {
    width: 100%;
    height: 100%;
  }
  .home-page-top {
    width: 375px;
    height: 170px;
    display: flex;
    background: url("./img/Btop.png") no-repeat 100%;
    background-size: 100% 100%;
    .top-img {
      width: 60px;
      height: 60px;
      margin: 24px 0 0 20px;
      img{
        border-radius: 50%;
      }
    }
    .top-p {
      padding-top: 38px;
      margin-left: 21px;
      font-size: 15px;
      font-weight: bold;
      color: #ffffff;
      p {
        &:last-child {
          margin-top: 3px;
          font-size: 11px;
          font-weight: Regular;
        }
      }
    }
  }
  .home-page-icon {
    width: 355px;
    height: 121px;
    display: flex;
    align-items: center;
    margin: -59px auto 0 auto;
    background: url("./img/Bicon.png") no-repeat 100%;
    background-size: 100% 100%;
    .page-icon-size {
      width: 50px;
      text-align: center;
      font-size: 12px;
      color: #333333;
      .icon-size {
        width: 38px;
        height: 38px;
      }
      &:nth-child(1) {
        margin-left: 45px;
      }
      &:nth-child(2) .icon-size,
      &:nth-child(4) .icon-size {
        width: 1px;
        height: 24px;
      }
    }
  }
}
.myhome-page {
  height: 100vh;
  background: #fff;
  .myhome-info {
    .myhome-info-top {
      padding-top: 45px;
      text-align: center;
      .home-info-name {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
        font-family: PingFang SC;
      }
      .home-info-card {
        margin: 12px auto 11.5px auto;
        .svg-icon {
          width: 72.5px;
          height: 24.5px;
        }
      }
      .home-info-phone {
        display: flex;
        justify-content: center;
        .svg-icon {
          width: 17px;
          height: 17px;
        }
      }
      .hoem-page-info {
        display: flex;
        justify-content: center;
      }
      .hoem-page-info2 {
        margin-top: 17px;
      }
      .hoem-page-info p:first-child {
        padding-right: 3.5px;
      }
    }
    .page-line {
      width: 292.5px;
      height: 0.5px;
      margin: 17px auto 13.5px auto;
      background: #ededed;
    }
    .page-line2 {
      margin: 14px auto 24px auto;
    }
    .myhome-info-bottom {
      margin-top: 29px;
      .info-list-top {
        width: 335px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .list-style {
          width: 105px;
          height: 46.5px;
          line-height: 46.5px;
          text-align: center;
          font-size: 14px;
          color: #666666;
          font-weight: Medium;
          font-family: PingFang SC;
          background: url("./img/myhome_bg1.png") no-repeat 100%;
          background-size: 100% 100%;
        }
        .list-check-style {
          color: #ffffff;
          background: url("./img/myhome_bg2.png") no-repeat 100%;
          background-size: 100% 100%;
        }
      }
      .info-list-bottom {
        width: 355px;
        margin: auto;
      }
      .info-dataList {
        width: 335px;
        margin: 25px auto 0 auto;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.5px solid #ededed;
        .svg-icon {
          width: 13.5px;
          height: 2px;
          display: block;
          margin-left: 5.5px;
          margin: 5.5px auto 0;
        }
        .li-style2 {
          // width: 24.5px;
          font-size: 12px;
          font-family: PingFang SC;
          color: #333333;
          font-weight: lighter;
        }
        .li-check-style2 {
          font-weight: Regular;
          color: #fc6e09;
        }
      }
    }
  }
  .product-list-title {
    margin: 12px 0 8px 18px;
    font-size: 14px;
    font-weight: Bold;
  }
  .product-list-summary {
    margin-left: 18px;
    font-size: 10.5px;
    font-weight: Regular;
  }
  .bank-list {
    width: 355px;
    margin-top: 15.5px;
    padding: 10.5px 0 9.5px 0;
    background: #ffffff;
    border-radius: 10px;
    .list-com {
      width: 335px;
      margin: auto;
    }
    .bank-top,
    .bank-top-left {
      height: 65px;
      display: flex;
    }
    .bank-left-img{
      width: 128px;
      height: 65px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .bank-top {
      justify-content: space-between;
      align-items: center;
    }
    .bank-bottom {
      height: 56.5px;
      margin-top: 12px;
      padding: 3.5px 0;
      line-height: 1.58;
      overflow: hidden;
      background: #f9f9f9;
      p {
        height: 14px;
        padding-left: 17.5px;
        font-size: 10px;
      }
    }
  }
  .product-safe {
    height: 135px;
    padding: 0;
    align-items: center;
    display: flex;
    .product-safe-left {
      width: 128px;
      height: 110px;
      margin-left: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .product-safe-right {
      // border: 1px solid;
      width: 195.5px;
      height: 110px;
      margin-left: 11.5px;
      position: relative;
      .safe-right-but {
        position: absolute;
        bottom: 0;
        right: 0;
      }
      .safe-right-height {
        height: 48px;
        overflow: hidden;
      }
      .product-list-summary {
        margin-left: 0;
        height: 14px;
      }
      .product-list-title {
        margin: 10px 0 5px 6.5px;
      }
    }
  }
  .home-data-list {
    width: 345px;
    margin: 16.5px auto 0 auto;
    .home-list-sty {
      width: 100%;
      height: 93.5px;
      display: flex;
      align-items: center;
      border-bottom: 0.5px solid #ededed;
      .list-left {
        width: 94.5px;
        height: 57px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .list-right {
        width: calc(345px - 110px);
        margin-left: 15.5px;
      }
      .list-top-right {
        width: 100%;
        margin: 0;
      }
      .list-r-tit {
        line-height: 12.5px;
        display: flex;
        align-items: flex-start;
        span {
          display: block;
          width: 197px;
          height: 27px;
          line-height: 1.2;
          overflow-y: hidden;
          margin-left: 8px;
          font-size: 10.5px;
          font-weight: Medium;
          font-family: PingFang SC;
          color: #333333;
        }
        .svg-icon {
          width: 27.5px;
          height: 17px;
        }
      }
      .list-r-foot {
        height: 12.5px;
        line-height: 0;
        display: flex;
        margin-top: 20px;
        span {
          height: 12.5px;
          display: flex;
          font-size: 9px;
          font-weight: Regular;
          font-family: PingFang SC;
          color: #999999;
        }
        .list-top-span {
          color: #ff2e2e;
          margin-right: 5px;
        }
      }
      .list-r-foot span:last-child {
        padding-left: 5px;
      }
    }
  }
}
</style>